import { useEffect } from "react";
import { useAppDispatch } from "@hooks/useAppDispatch";
import { householdActions } from "@redux/household/household-slice";
import { formatDate } from "devextreme/localization";
import { ScrollView } from "devextreme-react";
import { useUniquePossibilities } from "@/hooks/useUniquePossibilities";
import { useParams } from "react-router";
import withDisclaimer from "@/hoc/withDisclaimer";
import HouseholdContact from "./HouseholdContact";
import HouseholdInfo from "./HouseholdInfo";

function Household() {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { data: upData, isLoading, isRefetching, isSuccess } = useUniquePossibilities(id!);

  const household = upData?.household;
  const primaryContact = upData?.household?.primaryContact;
  const secondaryContact = upData?.household?.secondaryContact;

  useEffect(() => {
    if (isLoading || isRefetching) {
      dispatch(
        householdActions.setHeader({
          title: "Household",
          isLoading: true,
        })
      );
    } else if (isSuccess) {
      dispatch(
        householdActions.setHeader({
          content: `For ${household?.name ?? ""}, based on information furnished ${formatDate(new Date(), "longDate")}`,
          title: "Household",
        })
      );
    }

    return () => {
      dispatch(
        householdActions.setHeader({
          content: ``,
          title: "",
        })
      );
    };
  }, [dispatch, isLoading, isRefetching, isSuccess, household?.name]);

  return (
    <ScrollView height={"80%"} showScrollbar="never">
      <div className="flex w-1/3 flex-col gap-8 rounded-md bg-neutral-500 p-8 text-neutral-100 print:w-full">
        <div className="flex flex-1 flex-col gap-4">
          <HouseholdInfo household={household} isLoading={isLoading} isRefetching={isRefetching} />
        </div>
        <HouseholdContact
          isLoading={isLoading}
          isRefetching={isRefetching}
          contact={primaryContact}
          isPrimary
        />
        {secondaryContact && (
          <HouseholdContact
            isLoading={isLoading}
            isRefetching={isRefetching}
            contact={secondaryContact}
          />
        )}
      </div>
    </ScrollView>
  );
}

const HouseholdWithDisclaimer = withDisclaimer(Household);

export default HouseholdWithDisclaimer;
